import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useListSizingExperiments from "@babackapp/private-api-client/client/use-list-sizing-experiments";
import { Loader2 } from "lucide-react";
import { ExperimentsTable } from "./components/experiments-table";
import { CreateExperimentDialog } from "./components/create-experiment-dialog";

// craftsman-ignore: TS002
export default function SizingExperimentsPage() {
  const { data: shop } = useCurrentShopSuspense();
  const { data: experiments, isLoading } = useListSizingExperiments(shop.id);

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-[1200px] lg:px-16 lg:py-6 px-6 py-4 space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <h2 className="text-2xl font-semibold text-foreground">
              A/B Testing
            </h2>
            <p className="text-sm text-muted-foreground">
              Manage sizing widget experiments to measure impact on conversion
              and return rates.
            </p>
          </div>
          <CreateExperimentDialog shopId={shop.id} />
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center h-32">
            <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <ExperimentsTable
            experiments={experiments ?? []}
            shopId={shop.id}
          />
        )}
      </div>
    </div>
  );
}
